import { render, staticRenderFns } from "./bed.vue?vue&type=template&id=2e6a34f1"
import script from "./bed.vue?vue&type=script&lang=js"
export * from "./bed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports